import { Decimal } from 'decimal.js';
import { BSAFormula } from '../../database/schema.js';
export function calculateDecimalBSA(height, weight, precision = 4, method) {
    if (!Number.isFinite(height) || !Number.isFinite(weight) || height <= 0 || weight <= 0)
        return 0;
    const h = new Decimal(height);
    const w = new Decimal(weight);
    let result;
    switch (method) {
        case 'MOSTELLER':
            result = w.mul(h).div(3600).sqrt();
            break;
        case 'HAYCOCK':
            result = new Decimal('0.024265').mul(h.pow('0.3964')).mul(w.pow('0.5378'));
            break;
        default:
            // du bois method
            result = new Decimal('0.007184').mul(h.pow('0.725')).mul(w.pow('0.425'));
            break;
    }
    return result.toDecimalPlaces(precision).toNumber();
}
//# sourceMappingURL=bsa.js.map